import { $ } from '@situation/setdesign.util';

/* global moment */
class SlideFilter {
    constructor($main, $nav) {
        this.expired = [];
        this.now = moment();
        this.$main = $main;
        this.$nav = $nav;
        this.$navItems = $nav.find('.home-slider__nav-item');
        this.$slides = $main.find('.home-slider-card');
        this.messages = $main.parents('.home-slider').data('messages');
        this.$navItems.each((index, element) => {
            this.setMessage(index, element);
        });

        this.expired.reverse();
        this.expired.forEach((value) => {
            this.$navItems.eq(value).remove();
            this.$slides.eq(value).remove();
        });
    }

    setMessage(_index, item) {
        const $item = $(item);
        const expiry = $item.data('expiration');
        const onSale = $item.data('onsale');
        if (expiry) {
            const expiryDate = moment(expiry);
            if (this.now.isSameOrAfter(expiryDate)) {
                this.expired.push($item.index());
            }
        }
        if (onSale) {
            const onSaleDate = moment(onSale);
            const prop = this.now.isSameOrAfter(onSaleDate) ? 'on_sale' : 'pre_sale';
            const message = this.messages && Object.prototype.hasOwnProperty.call(this.messages, prop)
                ? this.messages[prop]
                : false;
            if (message) {
                $item.find('.home-slider__nav-item-link').html(message);
            }
        }
    }
}

export default SlideFilter;
